import React, { useContext, useEffect, useState } from "react";
import images from "constants/images";
import toast from "react-hot-toast";
import StorageService from "utils/StorageServices";
import { paymentVoucherApi } from "_services";
import { utils } from "helper";
import { UserContext } from "context";
import { CrossButton, SkeletonInput } from "components";
import AttachedFileModal from "modals/AttachedFileModal";
import './paymentVoucher.css'
import { Link, useNavigate } from "react-router-dom";
import useDocumentTitle from "hooks/useDocumentTitle";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { FiPrinter } from "react-icons/fi";

const PaymentVoucher = ({ paymentVoucherOpen, closeModal, voucherId, oprnDeleteModal = () => { }, expenseId,
  showLrNumber = false, onPrintHandle = () => { }, printLoadingId = null, deletePrintBtn = true }) => {
  const [details, setDetails] = useState("");
  const [detailsLoading, setDetailsLoading] = useState(false);
  const { masterData } = useContext(UserContext);
  const [showAttachedModal, setShowAttachedModal] = useState({
    open: false,
    data: [],
  });

  const navigate = useNavigate()
  useDocumentTitle("Payment Voucher | T360");

  useEffect(() => {
    callBackPayment(paymentVoucherOpen);
  }, [paymentVoucherOpen]);

  const callBackPayment = async (data) => {
    const payload = {
      company_id: StorageService?.getCompanyId(),
      voucher_id: voucherId,
    };
    setDetailsLoading(true);

    try {
      const res = await paymentVoucherApi(payload);
      if (res?.responseCode == 200) {
        setDetailsLoading(false);
        setDetails(res?.data?.voucher);
      } else {
        setDetailsLoading(false);
        toast.error(res?.responseMessage);
      }
    } catch (error) {
      setDetailsLoading(false);
      toast.error(error?.message);
    }
  };

  let attachedModal = {
    isOpen: showAttachedModal?.open,
    closeModal: (e) =>
      setShowAttachedModal((pre) => ({ ...pre, open: false, data: [] })),
    headerPart: false,
    footerPart: false,
    modalMainClass: "_dashCommon_Modal _AttachmentModal",
    modalTitle: "Attachment",
    submitTitle: "Add",
    cancelButtonTitle: "Cancel",
    showAttachedModal: showAttachedModal,
    // getMaterial: (e) => getMaterial()
    // getBanner: (e) => getBanner()
  };

  const noTransactionStyle = {
    padding: "10px 0",
    fontSize: "14px",
    color: "#999",
    textAlign: "center",
    borderBottom: "0px solid #ddd",
  };

  const NoTransactionRow = () => (
    <div style={noTransactionStyle}>No Transaction</div>
  );

  const hasTripNumber = details?.categories?.some(exp => exp?.trip_number);
  const currentId = expenseId ?? voucherId;
  console.log("currentId", expenseId)
  return (
    <>
      <div
        className={`offcanvas offcanvas-end common_offCanvas lgOffcanvas ${paymentVoucherOpen ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: paymentVoucherOpen ? "visible" : "hidden" }}
      >
        <>
          <div className="offcanvas-header">
            <h5 className="offcanvas-title"> Payment Voucher </h5>
            <CrossButton type="button" className="_switchBtn  __animEffect_btn" style={{ marginLeft: 'auto' }} onClick={closeModal} >
              <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path
                  d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
                  fill="black"
                />
              </svg>
            </CrossButton>
          </div>
          {details && (
            <div className="offcanvas-body" style={{ flex: "1" }}>
              {deletePrintBtn && <div className="__pvReactBx">
                {/* <button>
                  <img src={images.EDITLG_ICON.default} alt="" />
                  &nbsp; Edit
                </button> */}
                <button
                  onClick={() => onPrintHandle(currentId)}
                  disabled={printLoadingId === currentId}
                >
                  {printLoadingId === currentId ? (
                    <AiOutlineLoading3Quarters
                      className="spinLoader"
                      size={20}
                      style={{ color: "#3f51b5" }}
                    />
                  ) : (
                    <img src={images.FLPRINT_ICON.default} alt="" />
                  )}
                  &nbsp; Print
                </button>


                {paymentVoucherOpen?.type != 21 && <button onClick={() => oprnDeleteModal(true)}>
                  <img src={images.UIWDELETE_ICON.default} alt="" />
                  &nbsp; Delete
                </button>}
              </div>}

              <div className="__nxlPay_vc">
                <div className="__nxlPay_flex" style={{ marginBottom: "20px" }}>
                  <div className="__nxlPay_duo">
                    <h5>Transaction Type</h5>
                    <p>
                      {details?.sub_type_name
                        ? details?.sub_type_name
                        : details?.type_name}
                    </p>
                  </div>
                  <div className="__nxlPay_duo">
                    <h5>Voucher Number</h5>
                    <p>{`#${details?.sequence_no ? details?.sequence_no : details?.voucher_no}`}</p>
                  </div>
                </div>
                <div className="__nxlPay_flex">
                  <div className="__nxlPay_duo">
                    <h5>Transaction Date</h5>
                    <p>{`${utils.formatDateMonth(
                      details?.date
                    )} | ${utils?.formatTime(details?.date)}`}</p>
                  </div>
                  <div className="__nxlPay_duo">
                    <h5>Status</h5>
                    <span
                      className={`__nxlPay_pendStatus ${details?.approval_status === 1
                        ? "pending"
                        : details?.approval_status === 2
                          ? "hold"
                          : details?.approval_status === 2
                            ? "approved"
                            : details?.approval_status === 4
                              ? "rejected"
                              : details?.approval_status === 5
                                ? "complete"
                                : details?.approval_status === 0
                                  ? "complete"
                                  : ""
                        }`}
                    >
                      {" "}
                      {
                        masterData?.payment_approval_status[
                        details?.approval_status == 0
                          ? 5
                          : details?.approval_status
                        ]
                      }
                    </span>
                  </div>
                </div>
              </div>

              <table className="__nxlPay_table" style={{ marginTop: "7px" }}>
                <thead>
                  <tr>
                    <th style={{ width: "43%" }}>Expenses Category</th>
                    {showLrNumber && <th>LR Number</th>}
                    {hasTripNumber && <th>Trip Number</th>}
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {details?.categories?.map((exp, index) => (
                    <tr key={index}>
                      <td>{exp?.category?.name}</td>
                      {showLrNumber && (
                        <td>
                          {exp?.lr_number ? (
                            <>
                              <Link to={`/trip/addtrip/dispatched/${exp?.trip_id}?t=consignor_freight`}>
                                {exp?.lr_number}
                              </Link>
                            </>
                          ) : (
                            '-'
                          )}
                        </td>
                      )}
                      {hasTripNumber && (
                        <td>
                          {exp?.trip_number ? (
                            <Link to={`/trip/addtrip/dispatched/${exp?.trip_id}?t=freight`}>
                              {exp?.trip_number}
                            </Link>
                          ) : (
                            '-'
                          )}
                        </td>
                      )}
                      <td>₹ {(exp?.amount).toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td>Total</td>
                    {showLrNumber && <td></td>}
                    {hasTripNumber && <td></td>}
                    <td>
                      <span
                        style={{
                          color: "var(--light-invailid)",
                          fontWeight: "500",
                          opacity: "70%",
                        }}
                      >
                        {
                          details?.total_amount
                            ? `₹ ${Number(details.total_amount).toFixed(2)}`
                            : `₹ ${utils
                              .getTotalAmount(details?.categories, "amount")
                              ?.toFixed(2)}`
                        }

                        {/* {(details?.total_amount).toFixed(2)} */}
                      </span>
                    </td>
                  </tr>
                </tfoot>
              </table>

              <div className="__nxlPay_vc">
                <div className="__nxlPay_flex" style={{ marginBottom: "20px" }}>
                  {details?.payment_mode?.name && <div className="__nxlPay_duo">
                    <h5>Payment Mode : {details?.payment_mode?.name}</h5>
                    <p>{details?.payment_mode?.account?.name}</p>
                  </div>}
                  {details?.transaction_no && <div className="__nxlPay_duo">
                    <h5>Transaction Number</h5>
                    <p>{details?.transaction_no}</p>
                  </div>}
                </div>
                <div className="__nxlPay_flex" style={{ marginBottom: "20px" }}>
                  {details?.description && <div className="__nxlPay_long">
                    <h5>Description</h5>
                    <p>{details?.description}</p>
                  </div>}
                </div>
                <div className="__nxlPay_flex" style={{ marginBottom: "20px" }}>
                  {details?.vendor_detail?.name && <div className="__nxlPay_long">
                    <h5>
                      Vendor : {masterData?.vendor_type[details?.vendor_type]}
                    </h5>
                    <p>{`Name - ${details?.vendor_detail?.name}`}</p>
                    {details?.vendor_detail?.pan_no && <p>{`PAN No. - ${details?.vendor_detail?.pan_no}`}</p>}
                    {/* {details?.vendor_detail?.pan_image && <img src={`${masterData?.s3_url}${details?.vendor_detail?.pan_image}`}/>} */}
                    {details?.vendor_detail?.pan_image && <a className="p_colored pan_image">
                      <img src={`${masterData?.s3_url}${details?.vendor_detail?.pan_image}`} />

                    </a>}
                  </div>}
                </div>

                {(details?.vendor_bank_account?.account_number || details?.vendor_bank_account?.upi_id) && (
                  <div
                    className="__nxlPay_flex"
                    style={{ marginBottom: "20px" }}
                  >
                    <div className="__nxlPay_long">
                      <h5>Payment Bank</h5>
                      {details?.vendor_bank_account?.ifsc_code && <>
                        <p>{`Bank - ${details?.vendor_bank_account?.bank_name
                          ? `${details?.vendor_bank_account?.bank_name} `
                          : ""
                          } `}</p>
                        <p>{`A/C Name - ${details?.vendor_bank_account?.account_name
                          ? `${details?.vendor_bank_account?.account_name} `
                          : ""
                          } `}</p>
                        <p>{`A/C No - ${details?.vendor_bank_account?.account_number
                          ? `${details?.vendor_bank_account?.account_number} `
                          : ""
                          } `}</p>
                        <p>
                          {" "}
                          {`IFSC - ${details?.vendor_bank_account?.ifsc_code || ""
                            }`}
                        </p>
                      </>
                      }
                      {details?.vendor_bank_account?.upi_id && <p>
                        {" "}
                        {`UPI ID - ${details?.vendor_bank_account?.upi_id || ""
                          }`}
                      </p>}
                    </div>
                  </div>
                )}
                {details?.tags?.ownership && (
                  <div className="__nxlPay_flex" style={{ marginBottom: "20px" }}>
                    <div className="__nxlPay_long">
                      <h5>Relations</h5>
                      <p>
                        {[
                          details?.tags?.vehicle?.vehicle_no &&
                          `Vehicle : ${details.tags.vehicle.vehicle_no.slice(0, 4)
                          } ${details.tags.vehicle.vehicle_no.slice(4, 6)} ${details.tags.vehicle.vehicle_no.slice(6)}`,

                          details?.tags?.ownership &&
                          `Ownership : ${details.tags.ownership}`,

                          details?.tags?.driver &&
                          `Driver : ${details.tags.driver.name}`,

                          details?.tags?.supplier &&
                          `Supplier : ${details.tags.supplier.name}`,

                          details?.tags?.month &&
                          `Month : ${details.tags.month}`,

                          details?.tags?.year &&
                          `Year : ${details.tags.year}`,
                        ]
                          .filter(Boolean)
                          .join(", ")}
                      </p>
                    </div>
                  </div>
                )}


                {details?.file?.length > 0 && <div className="singleDiv">
                  <div className="_attatchmentBxs" style={{ gap: "8px" }}>
                    <p>Attach Files</p>
                    <div className="img_fnex_src">
                      {details?.file?.length > 0 &&
                        details?.file?.map((el, index) => {
                          return (
                            <>
                              <div
                                className="pos-relative"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setShowAttachedModal((pre) => ({
                                    ...pre,
                                    open: true,
                                    data: details?.file,
                                  }));
                                }}
                              >
                                <img
                                  className="_pdfIcon_sigxe"
                                  src={`${masterData?.s3_url}${el?.path}`}
                                  alt=""
                                />
                              </div>
                            </>
                          );
                        })}
                    </div>
                  </div>
                </div>}
              </div>

              <div className="__jrdEntry">Journal Entry</div>
              <table className="__nxlPay_table">
                <thead>
                  <tr>
                    <th style={{ width: "43%" }}>Account</th>
                    <th>Debit</th>
                    <th>Credit</th>
                  </tr>
                </thead>
                <tbody>
                  {details?.transaction_id?.entries?.length >
                    0 ? (details?.transaction_id?.entries.map((ent) => (
                      <tr>
                        <td>{ent?.account?.name}</td>
                        <td>
                          {ent?.debit_amount
                            ? `₹ ${ent?.debit_amount.toFixed(2)}`
                            : "₹ 0.00"}
                        </td>
                        <td>
                          {ent?.credit_amount
                            ? `₹ ${ent?.credit_amount.toFixed(2)}`
                            : "₹ 0.00"}
                        </td>
                      </tr>
                    ))) : (
                    <tr style={{ borderBottom: "2px solid #ddd", alignItems: "center" }}>
                      <NoTransactionRow />
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </>
      </div>
      <div className={paymentVoucherOpen ? "offBack_drop" : ""}></div>
      {showAttachedModal?.open && <AttachedFileModal {...attachedModal} />}
    </>
  );
};

export default PaymentVoucher;
